/**
 * Formularz danych do faktury dla Usług Płatnych Cyklicznie
 * Obsługuje pola związane z danymi dodatkowego podmiotu na fakturze, w szczególności:
 * - przełączanie typu identyfikatora podatkowego (NIP, NUMER ID, WEWNĘTRZNE ID, BRAK ID)
 * - zapewnia sterowanie wymagalnością pól formularza
 */
app.service('subscriptionServiceAdditionalEntityInvoice', function (regon, percentageShare) {

	function init(props) {

		let employeeAddressRequired;
		let $self, $invoiceAddress, $taxIdTypeSelector, $roleSelector, $taxIdTypeBoxes, $employeeAddressCheckbox, $numberId, $nip, $companyName, $internalId, $roleDescription,
			$percentageShare, $employeeName, $additionalInvoiceHeader, $numberIdCountryCode, $additionalInvoiceEmail;

		const {$form, onChange} = props;

		setElements($form);
		setEvents($form, onChange);
		percentageShare.init($percentageShare);
		employeeAddressRequired = $self.find('input[name=employeeAddressRequired]').is(':checked');

		function setEvents($form, onChange) {

			$form.find('.select3-input').select3();

			$numberIdCountryCode.on('change', function () {
				$form.validate().element($numberIdCountryCode);
			});

			$self
				.on('change', `input[name="additionalInvoiceEntity.taxIdType"]`, function handleTaxIdentifierChange() {
					onChange({additionalEntityTaxId: $(this).val()});
				})
				.on('change', 'input[name=employeeAddressRequired]', function handleEmployeeAddressCheckboxChange() {
					employeeAddressRequired = $(this).is(':checked');
					onChange();
				})
				.on('change', `input[name="additionalInvoiceEntity.role"]`, function handleRoleChange() {
					const role = $(this).val();

					if (role === 'EMPLOYEE') {
						const taxIdType = 'EMPTY_ID';
						$taxIdTypeSelector.val(taxIdType).trigger('change');
						onChange({additionalEntityRole: role, additionalEntityTaxId: taxIdType});
					} else {
						onChange({additionalEntityRole: role});
					}
				});

			$self.find('.select3-input').select3();
			$self.find('input[name="additionalInvoiceEntity.address.zipCode"]').mask2('99-999').keyfilter(/[\d\-]/);

			$numberId.prev('[contenteditable]').on('input', function () {
				$numberId.val($(this).text());
				$form.validate().element($numberId);
			});

			autocompleteDelivery(
				$self.find('input[name="additionalInvoiceEntity.address.zipCode"]').attr('id'),
				$self.find('input[name="additionalInvoiceEntity.address.city"]').attr('id')
			);

			regon.init({
				$box: $self.find('.regon-box'),
				$nip: $self.find('input[name="additionalInvoiceEntity.nip"]'),
				$companyName: $self.find('input[name="additionalInvoiceEntity.companyName"]'),
				$city: $self.find('input[name="additionalInvoiceEntity.address.city"]'),
				$street: $self.find('input[name="additionalInvoiceEntity.address.street"]'),
				$houseNumber: $self.find('input[name="additionalInvoiceEntity.address.houseNumber"]'),
				$flatNumber: $self.find('input[name="additionalInvoiceEntity.address.flatNumber"]'),
				$zipCode: $self.find('input[name="additionalInvoiceEntity.address.zipCode"]')
			});
		}

		function setElements($form) {
			$self = $form.find('.additional-invoice-section');
			$taxIdTypeSelector = $self.find('input[name="additionalInvoiceEntity.taxIdType"]');
			$roleSelector = $self.find('input[name="additionalInvoiceEntity.role"]');
			$invoiceAddress = $self.find('.invoice-address-box').find('input:not([name="additionalInvoiceEntity.address.flatNumber"]), textarea');
			$taxIdTypeBoxes = $self.find('.tax-id-type-box');
			$employeeAddressCheckbox = $self.find('');
			$numberId = $self.find('textarea[name="additionalInvoiceEntity.numberId"]');
			$nip = $self.find('input[name="additionalInvoiceEntity.nip"]');
			$companyName = $self.find('input[name="additionalInvoiceEntity.companyName"]');
			$internalId = $self.find('input[name="additionalInvoiceEntity.internalId"]');
			$roleDescription = $self.find('textarea[name="additionalInvoiceEntity.roleDescription"]');
			$percentageShare = $self.find('input[name="additionalInvoiceEntity.percentageShare"]');
			$employeeName = $self.find('input[name="additionalInvoiceEntity.employeeName"]');
			$additionalInvoiceHeader = $self.find('.additional-invoice-form-header');
			$numberIdCountryCode = $self.find('input[name="additionalInvoiceEntity.numberIdCountryCode"]');
			$additionalInvoiceEmail = $self.find('input[name="additionalInvoiceEntity.email"]');
		}

		function setTaxIdTypeBox(props) {
			$taxIdTypeBoxes
				.removeClass('active')
				.filter((i, el) => el.dataset.type === props.additionalEntityTaxId)
				.addClass('active');
		}

		function getViewState(props) {
			const isEmployeeRole = props.additionalEntityRole === 'EMPLOYEE';
			const isAdditionalBuyerRole = props.additionalEntityRole === 'ADDITIONAL_BUYER';
			const isTaxPayerRole = props.taxPayerRoleJst || props.taxPayerRoleGrv;

			return {
				// --- widoczność sekcji
				isExpanded: props.showAdditionalInvoice,
				isEmployeeRoleSelected: isEmployeeRole,
				isTaxPayerRole: isTaxPayerRole,
				hideEmployeeAddress: isEmployeeRole && !employeeAddressRequired,
				hideAdditionalInvoicePercentageShare: !props.showAdditionalInvoice || !isAdditionalBuyerRole,
				hideAdditionalInvoiceRoleDescription: !props.showAdditionalInvoice || props.additionalEntityRole !== 'OTHER_ROLE',
				hideAdditionalInvoiceEmail: !props.showAdditionalInvoice || !isAdditionalBuyerRole,
				isTaxIdTypeSelectorDisabled: isEmployeeRole,

				// --- stan pól (do walidacji)
				disableAllFields: !props.isCompanyUserType || !props.showAdditionalInvoice,
				disableInvoiceAddress: isEmployeeRole && !employeeAddressRequired,
				disableRoleSelector: isTaxPayerRole,
				disableNip: props.additionalEntityTaxId !== 'NIP',
				disableNumberId: props.additionalEntityTaxId !== 'NUMBER_ID',
				disableNumberIdCountryCode: props.additionalEntityTaxId !== 'NUMBER_ID',
				disableInternalId: props.additionalEntityTaxId !== 'INTERNAL_ID',
				disableCompanyName: isEmployeeRole,
				disableEmployeeName: !isEmployeeRole,
				disablePercentageShare: props.additionalEntityRole !== 'ADDITIONAL_BUYER',
				disableRoleDescription: props.additionalEntityRole !== 'OTHER_ROLE',
				disableAdditionalInvoiceEmail: !isAdditionalBuyerRole
			};
		}

		function setFieldState($field, shouldBeDisabled) {
			if ($field.prop('disabled') !== shouldBeDisabled) {
				$field.prop('disabled', shouldBeDisabled).ignore(shouldBeDisabled);
			}
		}

		function updateValidation(state) {

			if (state.disableAllFields) {
				[
					$invoiceAddress,
					$numberId,
					$nip,
					$companyName,
					$internalId,
					$roleDescription,
					$percentageShare,
					$employeeName,
					$numberIdCountryCode,
					$roleSelector,
					$taxIdTypeSelector,
					$additionalInvoiceEmail
				].forEach($field => setFieldState($field, true));
				return;
			}

			setFieldState($invoiceAddress, state.disableInvoiceAddress);
			setFieldState($roleSelector, false);
			setFieldState($taxIdTypeSelector, false);
			setFieldState($nip, state.disableNip);
			setFieldState($numberId, state.disableNumberId);
			setFieldState($numberIdCountryCode, state.disableNumberIdCountryCode);
			setFieldState($internalId, state.disableInternalId);
			setFieldState($companyName, state.disableCompanyName);
			setFieldState($employeeName, state.disableEmployeeName);
			setFieldState($percentageShare, state.disablePercentageShare);
			setFieldState($roleDescription, state.disableRoleDescription);
			setFieldState($additionalInvoiceEmail, state.disableAdditionalInvoiceEmail);
		}

		function render(props) {

			const state = getViewState(props);

			$taxIdTypeSelector.closest('.row-select').toggleClass('row-select-disabled', state.isTaxIdTypeSelectorDisabled);
			$roleSelector.closest('.row-select').toggleClass('row-select-disabled', state.disableRoleSelector);

			$self.toggleClass('is-expanded', state.isExpanded);
			$self.toggleClass('employee-role-selected', state.isEmployeeRoleSelected);
			$self.toggleClass('hide-employee-address', state.hideEmployeeAddress);
			$self.toggleClass('hide-additional-invoice-percentage-share', state.hideAdditionalInvoicePercentageShare);
			$self.toggleClass('hide-additional-invoice-role-description', state.hideAdditionalInvoiceRoleDescription);
			$self.toggleClass('hide-additional-invoice-email', state.hideAdditionalInvoiceEmail);

			setTaxIdTypeBox(props);
			updateTaxPayerRole(props);
			updateAvailableTaxIdTypes(props);
			updateInvoiceHeader(props);
			updateValidation(state);
		}

		function updateInvoiceHeader(props) {
			let labelClass = '.default-label';
			if (props.taxPayerRoleGrv) {
				labelClass = '.grv-label';
			}
			if (props.taxPayerRoleJst) {
				labelClass = '.jst-label';
			}
			$additionalInvoiceHeader.find(labelClass)
				.addClass('active')
				.siblings()
				.removeClass('active');
		}

		function updateTaxPayerRole(props) {
			const isTaxPayerRole = props.taxPayerRoleJst || props.taxPayerRoleGrv;
			$roleSelector.closest('.row-select').toggleClass('row-select-disabled', isTaxPayerRole);
			$roleSelector.val(props.additionalEntityRole).trigger('check');
			$taxIdTypeSelector.val(props.additionalEntityTaxId).trigger('check');
		}

		function updateAvailableTaxIdTypes(props) {
			const isTaxPayerRole = props.taxPayerRoleJst || props.taxPayerRoleGrv;
			const $taxIdTypeOptions = $taxIdTypeSelector.parent().find('.select3-option');

			$taxIdTypeOptions.addClass('is-hidden');

			if (props.additionalEntityRole === 'ADDITIONAL_BUYER') {
				const taxIdType = props.invoiceTaxIdType;
				if (taxIdType === 'NIP') {
					$taxIdTypeOptions
						.filter('[data-value=NIP], [data-value=INTERNAL_ID]')
						.removeClass('is-hidden');
				} else if (taxIdType === 'NUMBER_ID' || taxIdType === 'EMPTY_ID') {
					$taxIdTypeOptions
						.filter('[data-value=NUMBER_ID], [data-value=EMPTY_ID]')
						.removeClass('is-hidden');
				}
			} else if (isTaxPayerRole) {
				$taxIdTypeOptions
					.filter('[data-value="NIP"], [data-value="INTERNAL_ID"]')
					.removeClass('is-hidden');
			} else {
				$taxIdTypeOptions.removeClass('is-hidden');
			}
		}

		return {
			render
		}
	}

	return {
		init
	};
});

